export default "__VITE_PUBLIC_ASSET__8dc3663e__"